import { isArray, isNumber, isString } from 'lodash-es';
import { css } from 'styled-components';
const sizes = {
  giant: 1170,
  desktop: 992,
  tablet: 768,
  phone: 376
};

// iterate through the sizes and create a media template
// eslint-disable-next-line import/prefer-default-export
export const media = Object.keys(sizes).reduce((accumulator, label) => {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  const emSize = sizes[label] / 16;
  // eslint-disable-next-line no-param-reassign
  accumulator[label] = style => css`
    @media (max-width: ${emSize}em) {
      ${style};
    }
  `;
  return accumulator;
}, {});
export const getMediaSize = (size, theme) => {
  if (size === 'xs') return theme.mediaXs;
  if (size === 'sm') return theme.mediaSm;
  if (size === 'md') return theme.mediaMd;
  return theme.mediaLg;
};
export const getValue = (value, size) => {
  if (isString(value) || isNumber(value) || isArray(value)) return value;
  return value[size];
};
export const generateResponsiveTemplate = (value, cssProperty, getValueTemplate = ({
  originalValue
}) => originalValue) => {
  if (!value) return '';
  return css`
    ${(value.xs || isString(value) || isNumber(value)) && css`
      ${[cssProperty]}: ${({
    theme
  }) => getValueTemplate({
    originalValue: getValue(value, 'xs'),
    theme
  }) || getValue(value, 'xs')};
    `}

    ${value.sm && css`
      @media (min-width: ${({
    theme
  }) => getMediaSize('sm', theme)}) {
        ${[cssProperty]}: ${({
    theme
  }) => getValueTemplate({
    originalValue: getValue(value, 'sm'),
    theme
  }) || getValue(value, 'sm')};
      }
    `}

      ${value.md && css`
      @media (min-width: ${({
    theme
  }) => getMediaSize('md', theme)}) {
        ${[cssProperty]}: ${({
    theme
  }) => getValueTemplate({
    originalValue: getValue(value, 'md'),
    theme
  }) || getValue(value, 'md')};
      }
    `}

      ${value.lg && css`
      @media (min-width: ${({
    theme
  }) => getMediaSize('lg', theme)}) {
        ${[cssProperty]}: ${({
    theme
  }) => getValueTemplate({
    originalValue: getValue(value, 'lg'),
    theme
  }) || getValue(value, 'lg')};
      }
    `}
  `;
};
//# sourceMappingURL=styles-utils.js.map